import { Search } from '@frx/frx-program-defaults';

export const FindParticipant = () => <Search />;
